<template>
 
    <ModalLibroMayorDetalle :listDetalle="listDetalle" :totalGastos="totalGastos" :visible="modalVisible"   @update:visible="modalVisible  = $event" />
 
  <div>

 
 
<div class="flex justify-start " >     
  <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;CuentaPresupuestosSoloLectura&#62;</span>
</div>

<!-- Tarjeta de cabecera -->

<div
  class="ml-0 grid grid-cols-1 sm:grid-cols-6 gap-4 text-sm
         bg-white p-5 rounded-t-xl shadow-md border border-gray-100
         hover:shadow-lg transition duration-200 items-center"
>

  <!-- Centro -->
  <div>
    <div class="text-xs text-gray-500 uppercase tracking-wide">Centro</div>
    <div class="text-gray-800  font-mono">
        {{ centro.nombre }}
    </div>
  </div>

  <!-- Cuenta -->
  <div >
    <div class="text-xs text-gray-500 uppercase tracking-wide">Cuenta</div>
    <div class="text-gray-900   font-mono">
      {{   cuenta.cod  }} <br> {{ cuenta.nomcta }}
    </div>
  </div>

  <!-- Presupuesto -->
  <div>
    <div class="text-xs text-gray-500 uppercase tracking-wide">Presupuesto  {{ aa_consulta }}</div>
    <div class="text-gray-900   font-mono">
      $ {{ $formatoMiles(cuenta_total_presupuesto) }} 
    </div>
  </div>

  <!-- Gastos -->
  <div>
    <div class="text-xs text-gray-500 uppercase tracking-wide">Gastos  {{ aa_consulta }}</div>
    <div class="text-gray-900 font-mono">
      $ {{ $formatoMiles(cuenta.total_gastos) }}
    </div>
  </div>

  <!-- Saldo -->
  <div>
    <div class="text-xs text-gray-500 uppercase tracking-wide">Saldo</div>
    <div class="text-sm  font-mono"
         :class="cuenta.saldo < 0 ? 'text-red-600' : 'text-blue-600'">
      $ {{ $formatoMiles(cuenta.saldo) }}
    </div>
  </div>

  <!-- Botones -->
  <div class="flex justify-end items-center gap-2">

    <button v-if="borrador == false"
      @click="editar"
      title="detalle gastos"
      class="flex items-center justify-center w-10 h-10
             bg-violet-700 text-white rounded-full shadow
             hover:bg-violet-400 hover:shadow-md
             transition duration-150"
    >
      $
    </button>
     
    <button
      @click="toggleCuenta(cuenta.id)"
      title="detalle presupuesto"
      class="flex items-center justify-center w-12 h-12 text-white rounded-full shadow hover:shadow-md transition duration-150"
              :class="borrador 
    ? 'bg-green-700 hover:bg-green-400' 
    : 'bg-violet-700 hover:bg-violet-400'"
    >
      <span class="text-lg leading-none">
        {{ cuentaExpandida.includes(cuenta.id) ? '−' : '+' }}
      </span>
    </button>

  </div>

</div>
    <!-- Sección expandible -->
    <transition name="fade">
      <div
        v-if="revisaExpansion(cuenta.id)"
        class="mt-0 p-4 bg-gray-50 border border-gray-200 text-sm 
               text-gray-700   shadow-sm animate-fadeIn"
      >
     
       <IngresosMensualesSoloLectura  
          :borrador="borrador"
          :centro_id="centro.id"
          :propCuenta_id="cuenta.id"
          :nomcta="cuenta.nomcta"
          :nomcentro="centro.nombre"
          @toggleCuenta="toggleCuenta"
          @exit="exit"
          @getApiPresupuesto="getApiPresupuesto"
          :componenteVisible="componenteVisible" /> 
      </div>
    </transition>

  </div>
</template>

<script>
import api from "@/api/axios";
 
import ModalLibroMayorDetalle from "../libromayor/ModalLibroMayorDetalle.vue"; 
import IngresosMensualesSoloLectura from "./IngresosMensualesSoloLectura.vue";
 

export default {
  emits: ['toggleCuenta','reloadTotPresup'],
  props:
  {
    propCuenta: {
      type: Object
    },
    propCentro: {
      type: Object
    },
    cuentaExpandida: {
      type: Array
    },
    borrador:{
      type:Boolean
    }
 
  },
  data() {
    return {
      cuenta:{},
      cuenta_id: 0,
      modalVisible:false,
      componenteVisible:false,
      centro:{},
      cuenta_total_presupuesto:0,
 
      datosFromModalIngreso:{},
      listDetalle:[],
      saldo:0,
      totalGastos:0,
      aa_consulta:0
 
    }
  },
  methods: {
   
    toggleCuenta(id) {
 
      const i = this.cuentaExpandida.indexOf(id);
      if (i === -1) {
          console.log('esta oculta')
          this.componenteVisible=true;
      }
      
      this.$emit("toggleCuenta", id);
    },
    async getApiPresupuesto() 
    {
     
    this.$emit("reloadTotPresup",  this.cuenta.id   );
     

    },
    revisaExpansion(cuenta_id) {
      
      if ( typeof cuenta_id === "undefined"){
        return false
      }
      
      if (this.cuentaExpandida.includes(cuenta_id)) {
        return true;
      }
      return false;
    },
    exit(v){
        this.$emit("exit", v);
    },
    async editar() {



      const data = { cuenta_id: this.cuenta.id, centro_id: this.centro.id };
      if (this.borrador){
          data["borrador"] = this.borrador
        }
      const resp = await api.post(
        `/api/v1/presupuesto/gastos/`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      if (resp?.data?.error) {
        alert(resp.data.error);

        return;
      }
      if (resp){
        this.listDetalle = resp.data.librosdetalles;
        // acc = acumulador
        // d = cada elemento del array
        this.totalGastos = this.listDetalle.reduce((acc, d) => {
          return acc + Number(d.total_gastos);
        }, 0);
      }
      this.modalVisible = true;
      
    },
     inicializar(){
        this.aa_consulta =  this.$store.state.auth.userLogin.año  
        if (this.borrador)
        {
            this.aa_consulta = this.$store.state.auth.userLogin.año_borrador
        }
    },
  },
  mounted() {
    this.inicializar()
    this.cuenta=this.propCuenta;
    this.centro=this.propCentro;
    const centrocuentas = this.$store.state.centrocuentas.visibilidad;
    const cuentavisible = centrocuentas.filter(cta => cta.visible && cta.id === this.cuenta.id && cta.centro === this.centro.id)
    if (Array.isArray(cuentavisible) && cuentavisible.length > 0) {
      this.componenteVisible=false;
    }
      
    this.cuenta_total_presupuesto= this.cuenta.total_presupuesto;
    this.responsable_firstname=  this.centro?.usuarios[0]?.first_name 
    this.responsable_lastname=  this.centro?.usuarios[0]?.last_name
  },
  watch:{
     propCuenta: function(value){
       
        this.cuenta=value;
        this.cuenta_total_presupuesto = this.cuenta.total_presupuesto
      
     },
     propCentro: function(value){
       
        this.centro=value;
        this.cuenta_total_presupuesto = this.cuenta.total_presupuesto
      
     },
  },
  components: {
 
    IngresosMensualesSoloLectura ,
    ModalLibroMayorDetalle
  },

}
</script>